<template>
  <v-ons-page id="main" @show="onShow">
    <v-ons-tabbar position="bottom"
      :tabs="mainTabs"
      :index.sync="index"
    ></v-ons-tabbar>
  </v-ons-page>
</template>

<script>
export default {
  name: 'main-tabbar',
  props: ['pageParamsAfterLoad'],

  computed: {
    index: {
      get() {
        return this.$store.state.tabbar.index;
      },
      set(newValue) {
        this.navigatorSetMainTabbar(newValue);
      },
    },
    mainTabs() {
      let that = this;
      return this.$store.state.navigator.mainTabs.map((tab) => {
        let _tab = { ...tab };
        _tab.label = that.$t(`main_tabs.${_tab.label}`)
        return _tab;
      });
    },
  },

  methods: {
    onShow() {
      // Trigger promotion carousel / tiny slide re-render to workaround the missing carousel issue when home is hidden upon init load. e.g. user opened the app with an episode url
      window.dispatchEvent(new Event('resize'));
    },
  },

  mounted() {
    // TODO this breaks the carousel
    if (this.pageParamsAfterLoad && this.pageParamsAfterLoad.page !== 'MainTabbar' && (this.pageParamsAfterLoad.initFrom === 'main-tabbar' || this.pageParamsAfterLoad.initFrom === 'any')) {
      this.navigatorPush(this.pageParamsAfterLoad.page, this.pageParamsAfterLoad.props || {}, this.pageParamsAfterLoad.options || {});
    }
  },
};
</script>
